import { render, staticRenderFns } from "./Section5.vue?vue&type=template&id=3246bec5&scoped=true"
import script from "./Section5.vue?vue&type=script&lang=js"
export * from "./Section5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246bec5",
  null
  
)

export default component.exports